module.exports = __webpack_public_path__ + "img/AU.4bdfe88d.svg";